import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import stampCardInspirationFrame from '../../../../assets/vectors/stamp-card-inspiration-frame.svg';
import stampCardPassAndArrow from '../../../../assets/vectors/stamp-card-pass-and-arrow.svg';
import { CustomLightbulbIcon } from '../../../../theme/icons/CustomLightbulbIcon';

const StampCardInspirationModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
      <ModalOverlay />
      <ModalContent p={4}>
        <ModalHeader textAlign="center">
          Stamp card design tips & inspiration
        </ModalHeader>
        <ModalCloseButton _hover={{ bg: 'transparent', color: '#989898' }} />
        <ModalBody>
          <Flex direction="column" gap={4}>
            <Image
              src={stampCardInspirationFrame}
              alt="Stamp card pass design examples and inspiration"
              width="100%"
              height="auto"
              borderRadius="md"
              objectFit="contain"
            />
            <Flex align="center" gap={2}>
              <CustomLightbulbIcon
                flexShrink={0}
                width="16px"
                height="20px"
                aria-hidden
              />
              <Text textStyle="bodyFamilySemiBold" fontSize="14px">
                Tips for designing a great stamp card
              </Text>
            </Flex>
            <Text textStyle="bodyFamilyRegular" fontSize="12px">
              Use simple labels, clear layouts and strong colours so your pass
              is easy to read at a glance. Loyalty cards work best with around
              5-10 stamps - enough to motivate customers without feeling out of
              reach. Keep text short and make sure your design remains readable
              on bright phone screens.
            </Text>
            <Image
              src={stampCardPassAndArrow}
              alt="Stamp card pass example with on-device preview"
              width="100%"
              height="auto"
              borderRadius="md"
              objectFit="contain"
            />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default StampCardInspirationModal;
